import { render, staticRenderFns } from "./vertical-steps.vue?vue&type=template&id=b0683268&scoped=true"
import script from "./vertical-steps.vue?vue&type=script&lang=js"
export * from "./vertical-steps.vue?vue&type=script&lang=js"
import style0 from "./vertical-steps.vue?vue&type=style&index=0&id=b0683268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0683268",
  null
  
)

export default component.exports